import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../features/auth/auth.service';

/**
 * Admin role guard that checks if user is authenticated and has admin role
 * Redirects to appropriate route based on user role or to sign-in if not authenticated
 * NOTE: This guard is ready for when admin routes are implemented
 */
export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if user is authenticated
  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/auth/sign-in']);
  }

  // Check user role
  const userRole = authService.getUserRole();
  
  if (userRole === 'admin') {
    return true;
  }

  // If customer, redirect to customer dashboard
  if (userRole === 'customer') {
    return router.createUrlTree(['/customer/projects']);
  }

  // Fallback: redirect to sign-in
  return router.createUrlTree(['/auth/sign-in']);
};